import { render, staticRenderFns } from "./ft.vue?vue&type=template&id=33e3d9c4&scoped=true"
var script = {}
import style0 from "./ft.vue?vue&type=style&index=0&id=33e3d9c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e3d9c4",
  null
  
)

export default component.exports